export type DialogProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  title: string;
  children: React.ReactElement;
};

export const Dialog = ({ open, setOpen, title, children }: DialogProps) => (
  <dialog open={open}>
    <article>
      <header>
        <button
          aria-label="Close"
          rel="prev"
          onClick={() => setOpen(false)}
        ></button>
        <h3>{title}</h3>
      </header>
      {children}
      <footer>
        <button onClick={() => setOpen(false)}>Close</button>
      </footer>
    </article>
  </dialog>
);
